    angular.module('qkr').constant('COUNTRY', setConstant());
    function setConstant() {
        return {
            COLOMBIA: {CODE: 'co', NAME: 'Columbia'}
        };
    }



// WEBPACK FOOTER //
// ./src/constant/country.constants.js